module.exports = __webpack_public_path__ + "static/media/icon-404.2b35db99.svg";